import React, { Dispatch, SetStateAction, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from 'syngenta-digital-cropwise-react-ui-kit';
import { WizardStepSubTitle } from '../subviews/WizardStepSubTitle';
import Integration from 'models/Integration';

type ConfigureHandler = (configure: boolean) => void;

interface ImportStepProps {
  onConfigure: ConfigureHandler;
  importChecked: boolean;
  setImportChecked: Dispatch<SetStateAction<boolean>>;
  setDisableNextBtn: Dispatch<SetStateAction<boolean>>;
  integration: Integration;
}

export default function ImportStep({
  onConfigure,
  importChecked,
  setImportChecked,
  setDisableNextBtn,
  integration,
}: ImportStepProps) {
  const { t } = useTranslation();
  const handleCheckboxChange = (event: {
    target: { checked: boolean | ((prevState: boolean) => boolean) };
  }) => {
    setImportChecked(event.target.checked);
  };
  interface StyleProps {
    styleName: 'regular';
  }
  const styleClass = {
    regular: 'font-noto text-base font-normal leading-6 tracking-tight text-left',
  };
  const myStyleProps: StyleProps = { styleName: 'regular' };
  useEffect(() => {
    setDisableNextBtn(false);
  }, [setDisableNextBtn]);

  return (
    <>
      <div className="relative h-32 w-32 ...">
        <div
          className={`absolute left-0 font-normal bg-gray-700 py-24 ${
            styleClass[myStyleProps.styleName]
          }`}
          style={{ fontSize: '16px', lineHeight: '24px', letterSpacing: '-0.0075em' }}
        >{`${t('Import properties and fields from')} ${integration.integration_name}`}</div>
      </div>
      <div className="w-55% min-w-250 min-h-0 m-auto mt-60 pl-24 pb-24 pr-24 border-1 rounded-8 border-neutral-20 text-gray-300">
        <WizardStepSubTitle subTitle={t('Integration.import_fields')} />
        <div className="flex">
          <p className="text-left mr-30 text-gray-300">{t('Integration.ask_import')}</p>
          <Checkbox checked={importChecked} onChange={handleCheckboxChange} />
        </div>
        <div className="flex justify-end"></div>
      </div>
    </>
  );
}
